export const HUMAN_REQUEST_CONFIRMATION_MESSAGE = 'Thanks for reaching out! We will get back to you shortly.';

export const DEMO_TYPE = {
  ENTERPRISE_DEMO: 'ENTERPRISE_DEMO',
  ENTERPRISE_DEMO_IN_APP: 'ENTERPRISE_DEMO_IN_APP',
  WORKFLOW_DEMO: 'WORKFLOW_DEMO',
  WORKFLOW_DEMO_IN_APP: 'WORKFLOW_DEMO_IN_APP',
  REQUESTS_DEMO: 'REQUESTS_DEMO',
  EVENT_201801_PEPTALK: 'EVENT_201801_PEPTALK',
  EVENT_201802_SLAS: 'EVENT_201802_SLAS',
  EVENT_201802_TRICON: 'EVENT_201802_TRICON',
  EVENT_201810_LAKEPHARMA: 'EVENT_201810_LAKEPHARMA',
  EVENT_201810_LRIG: 'EVENT_201810_LRIG',
  EVENT_201810_PISTOIA_ALLIANCE: 'EVENT_201810_PISTOIA_ALLIANCE',
  EVENT_201902_FESTIVAL_BIOLOGICS: 'EVENT_201902_FESTIVAL_BIOLOGICS',
};

export const StartPreferences = {
  REQUESTED_DEMO_NAMESPACE: 'requestedDemo.',
};
